export interface QuickComment {
  label: string;
  shorthandLabel: string;
  suggestWhen: string[];
}

export interface QuickCommentGroup {
  name: string;
  items: QuickComment[];
}

export const quickComments: QuickCommentGroup[] = [
  {
    name: "LCD",
    items: [
      { label: "Cracked screen", shorthandLabel: "Cracked screen", suggestWhen: ["lcdBroken"] },
      { label: "Dim/backlight issue", shorthandLabel: "Backlight issue", suggestWhen: ["lcdBroken"] },
      { label: "Camera not working", shorthandLabel: "Camera not working", suggestWhen: ["cameraBroken"] },
      {
        label: "No display output (screen remains black, external display may or may not work)",
        shorthandLabel: "No display output",
        suggestWhen: ["lcdBroken"],
      },
      { label: "Laminate damage", shorthandLabel: "Laminate damage", suggestWhen: ["lcdBroken"] },
      { label: "Dead pixels", shorthandLabel: "Dead pixels", suggestWhen: ["dGrade", "lcdBroken"] },
      { label: "Lines or spots", shorthandLabel: "LCD lines/spots", suggestWhen: ["lcdBroken"] },
      {
        label: "Display discoloration (blue or yellow tint)",
        shorthandLabel: "Display disocoloration",
        suggestWhen: ["lcdBroken"],
      },
      {
        label: "Display flicker (intermittent screen flicker)",
        shorthandLabel: "Display flicker",
        suggestWhen: ["lcdBroken"],
      },
    ],
  },
  {
    name: "Keyboard",
    items: [
      { label: "Missing keys", shorthandLabel: "Missing keys", suggestWhen: ["dGrade"] },
      { label: "Sticky keys", shorthandLabel: "Sticky keys", suggestWhen: ["keyboardBroken"] },
      { label: "Worn or fading keys", shorthandLabel: "Worn keys", suggestWhen: ["dGrade"] },
      { label: "Non-functional keys", shorthandLabel: "Broken keys", suggestWhen: ["keyboardBroken"] },
      { label: "Backlight not working", shorthandLabel: "Broken backlight", suggestWhen: ["keyboardBroken"] },
    ],
  },
  {
    name: "Trackpad",
    items: [
      { label: "Not responsive", shorthandLabel: "Trackpad unresponsive", suggestWhen: ["trackpadBroken"] },
      { label: "Gestures not working", shorthandLabel: "Trackpad gestures broken", suggestWhen: ["trackpadBroken"] },
      { label: "Physical damage", shorthandLabel: "Trackpad physical damage", suggestWhen: ["trackpadBroken"] },
    ],
  },
  {
    name: "Battery",
    items: [
      { label: "Does not hold charge", shorthandLabel: "No charge", suggestWhen: ["batteryBroken"] },
      { label: "Battery removed", shorthandLabel: "No battery", suggestWhen: ["batteryBroken"] },
      { label: "Not detected", shorthandLabel: "Undetected battery", suggestWhen: ["batteryBroken"] },
    ],
  },
  {
    name: "Microphone",
    items: [
      { label: "Not working", shorthandLabel: "Mic broken", suggestWhen: ["microphoneBroken"] },
      { label: "Static or noise", shorthandLabel: "Mic static", suggestWhen: ["microphoneBroken"] },
    ],
  },
  {
    name: "Speaker",
    items: [
      { label: "Not working", shorthandLabel: "Speaker broken", suggestWhen: ["speakerBroken"] },
      { label: "Distortion or crackling", shorthandLabel: "Speaker distortion", suggestWhen: ["speakerBroken"] },
    ],
  },
  {
    name: "Ports",
    items: [
      { label: "USB (left) not working", shorthandLabel: "Left USB broken", suggestWhen: ["portsBroken"] },
      { label: "HDMI not working", shorthandLabel: "HDMI broken", suggestWhen: ["portsBroken"] },
      { label: "SD card slot not working", shorthandLabel: "SD card broken", suggestWhen: ["portsBroken"] },
      { label: "USB (right) not working", shorthandLabel: "Right USB broken", suggestWhen: ["portsBroken"] },
      { label: "Audio jack not working", shorthandLabel: "Audio jack broken", suggestWhen: ["portsBroken"] },
      { label: "Ethernet Port Failure", shorthandLabel: "Ethernet broken", suggestWhen: ["portsBroken"] },
    ],
  },
  {
    name: "Logic Board",
    items: [
      { label: "BIOS locked", shorthandLabel: "BIOS locked", suggestWhen: ["biosLocked"] },
      { label: "Overheating", shorthandLabel: "Overheating", suggestWhen: ["logicBroken"] },
      {
        label: "Power but no boot (lights on, no display or POST)",
        shorthandLabel: "Does not boot",
        suggestWhen: ["logicBroken"],
      },
      {
        label: "OS corrupted (stuck boot, missing system files)",
        shorthandLabel: "OS corrupted",
        suggestWhen: ["logicBroken"],
      },
      { label: "No recovery partition", shorthandLabel: "No recovery partition", suggestWhen: ["logicBroken"] },
      {
        label: "Fan not spinning or audible clicking",
        shorthandLabel: "Fan not spinning",
        suggestWhen: ["logicBroken"],
      },
      { label: "Bluetooth failure", shorthandLabel: "Bluetooth failure", suggestWhen: ["logicBroken"] },
      { label: "Does not power on", shorthandLabel: "Does not power on", suggestWhen: ["logicBroken", "powerBroken"] },
      { label: "Random shutdowns", shorthandLabel: "Random shutdowns", suggestWhen: ["logicBroken", "powerBroken"] },
      {
        label: "Stuck in reset loop (device continually reboots)",
        shorthandLabel: "Boot loop",
        suggestWhen: ["logicBroken", "powerBroken"],
      },
      {
        label: "Boot failure (fails to pass POST or reach OS)",
        shorthandLabel: "Boot failure",
        suggestWhen: ["logicBroken"],
      },
      { label: "Thermal failure", shorthandLabel: "Thermal failure", suggestWhen: ["logicBroken"] },
      {
        label: "Wireless failure (Wi-Fi card not detected or doesn't connect)",
        shorthandLabel: "Wireless failure",
        suggestWhen: ["logicBroken"],
      },
    ],
  },
  {
    name: "Cosmetic",
    items: [
      { label: "Sticker burn on exterior casing", shorthandLabel: "LCD Sticker burn", suggestWhen: ["dGrade"] },
      { label: "Sticker burn on palm rest", shorthandLabel: "Palmrest sticker burn", suggestWhen: ["dGrade"] },
      { label: "Sticker burn on bottom case", shorthandLabel: "Bottom sticker burn", suggestWhen: ["dGrade"] },
      { label: "Cracked bezel", shorthandLabel: "Cracked bezel", suggestWhen: ["dGrade"] },
      { label: "Loose or broken hinge", shorthandLabel: "Loose hinge", suggestWhen: ["dGrade"] },
      { label: "QR code etching on exterior", shorthandLabel: "QR code etch", suggestWhen: ["dGrade"] },
      { label: "Torn or worn gasket", shorthandLabel: "Torn gasket", suggestWhen: ["dGrade"] },
      { label: "Cracked or broken casing", shorthandLabel: "Broken casing", suggestWhen: ["dGrade"] },
    ],
  },
];
